export const TableTrackingCustomizationModalKey = 'table-tracking-modal';
